import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import {
  Alert,
  Body,
  Heading,
  // Link,
  Popover,
  Spinner,
  Button
} from "@walmart-web/livingdesign-components";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {  useSelector } from "react-redux";
// import { useDispatch } from "react-redux";
// import { AppDispatch } from "../../store/store";
import {  RootState } from "../../store/store";
// import { logResponseCopied, logSourceClicked } from "../../store/reducers/logthunks";
import { GenAISearchResponse, SourceDocument } from "../../types";
import { CopyIcon } from "../../assets/svgcomponents";
import styles from "./answer.module.css";
import { Close } from "@livingdesign/icons";
import axios from 'axios';

const Answer = ({
  filteredData,
  sources,
}: {
  filteredData: GenAISearchResponse;
  sources: SourceDocument[] | undefined;
}) => {
  const [answer, setAnswer] = useState<string>("");
  const [timestamp, setTimestamp] = useState("");
  const [copiedAlert, setCopiedAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New state for loading

  // const queryId = useSelector((state: RootState) => state?.querySearchLog?.queryId);
  // const dispatch = useDispatch() as AppDispatch;
  const answerFetching = useSelector((state: RootState) => state.genAIWaiting);
  const headersAre = useSelector((state: RootState) => state.headers);  
  let timer: any = undefined;
  // const isRespCopied = useSelector(
  //   (state: RootState) => state?.querySearchLog?.isResponseCopied
  // );
  // const isSourceClicked = useSelector(
  //   (state: RootState) => state?.querySearchLog?.isSourceClicked
  // );
  const ref: any = React.useRef();
  const [copyHover, setCopyHover] = useState(false);

  const formatDateTime = (timestamp: string) => {
    return new Date(timestamp).toLocaleString("en-US");
  };
  const formatAnswer = (answer: string) => {
    const newAnswer = answer.split("•");
    let finalAnswer;
    if (newAnswer.length > 1) {
      finalAnswer = newAnswer[0].trim() + "<ul>";
      for (let i = 1; i < newAnswer.length; i++) {
        const listStart = "<li>";
        const listEnd = "</li> ";
        finalAnswer += listStart + newAnswer[i].trim() + listEnd;
      }
      finalAnswer += "</ul>";
    } else {
      finalAnswer = answer;
    }
    return finalAnswer;
  };
  const handleCopyClick = () => {
    setCopiedAlert(true);
    clearTimeout(timer);
    timer = setTimeout(() => {
      setCopiedAlert(false);
    }, 3000);
    // if (!isRespCopied) {
    //   dispatch(logResponseCopied(queryId));
    // }
  };
  // const handleSourceClick = () => {
  //   if (!isSourceClicked) {
  //     dispatch(logSourceClicked(queryId));
  //   }
  // };
  useEffect(() => {
    if (!filteredData?.Answer) {
      return;
    }
    const formattedAnswer = formatAnswer(filteredData?.Answer);
    setAnswer(formattedAnswer);
    setTimestamp(new Date().toISOString());
  }, [filteredData]);

  return (
    <div className={styles.answerParent}>
      {answerFetching ? (
        <Spinner UNSAFE_className={styles.loadingSpinner} />
      ) : (
        <div className={styles.answerBodyParent}>
          <div className={styles.answerBody}>
            <Body UNSAFE_className={styles.answerBody}>
              {parse(answer)}
              {/* {answer?.map((el, i) => (
                                    <motion.span
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{
                                            duration: 0.25,
                                            delay: i / 50,
                                        }}
                                        key={i}
                                    >
                                        {el}{" "}
                                    </motion.span>
                                ))} */}
            </Body>
          </div>
          {filteredData?.Answer && (
            <div className={styles.answerMetrics}>
              <span className={styles.queryTimestamp}>
                {" "}
                Query executed on: {formatDateTime(timestamp)}
              </span>

              <Popover
                content={<div>copy</div>}
                UNSAFE_className={styles.copyPopover}
                position="bottomCenter"
                onClose={() => setCopyHover(false)}
                isOpen={copyHover}
                triggerRef={ref}
                hasNubbin={true}
              >
                {filteredData?.Answer ? (
                  <div
                    ref={ref}
                    onMouseEnter={() => setCopyHover(true)}
                    onMouseLeave={() => setCopyHover(false)}
                  >
                    <CopyToClipboard
                      onCopy={handleCopyClick}
                      text={`${filteredData?.Answer}`}
                    >
                      <span className={styles.copyIcon}>{CopyIcon}</span>
                    </CopyToClipboard>
                  </div>
                ) : (
                  <div className={styles.copyIcon}>{CopyIcon}</div>
                )}
              </Popover>
              {copiedAlert && (
                <Alert
                  variant="info"
                  UNSAFE_className={styles.responseCopyPopup}
                  actionButtonProps={{
                    children: <Close size="small" />,
                    onClick() {
                      setCopiedAlert(false);
                      clearInterval(timer);
                    },
                  }}
                >
                  Response copied!
                </Alert>
              )}
            </div>
          )}
          {sources ? (
            <div className={styles.answerSourcesParent}>
              <div className={styles.referencesHeading}>
                <Heading size="small">References:</Heading>
              </div>
              {sources?.map((source: SourceDocument, idx: number) => (
                <Button
                key={`source-${idx}`}
                onClick={async (event) => {
                  event.preventDefault();
                  setIsLoading(true); // Start loading
                  const fileId = source?.fileid; // replace with actual field
                  // const headers = headersAre; // your headers
                  try {
                    const url = window.location.href.includes('local') ? 'http://localhost:5000/download' : '/download';

                    // Make the API call to your server endpoint
                    const response = await axios.post(url,{id:fileId,isContent:true} ,{ headers: headersAre, responseType: 'blob' }); 
                    const file = new Blob(
                      [response?.data],
                      {type: 'application/pdf'});
                  const fileURL = URL.createObjectURL(file); // Create a URL from the Blob
                  window.open(fileURL, '_blank'); // Open the URL in a new tab
                  } catch (error) {
                    console.error('Error fetching PDF', error);
                  }
                  finally {
                    setIsLoading(false); // End loading
                  }
                }}
                style={{ width: "fit-content", backgroundColor: "transparent",color:"black" ,border: "none", boxShadow: "none", padding: "0", textAlign: "left"  }}
                onMouseOver={e => e.currentTarget.style.color = '#0056b3'}
                onMouseOut={e => e.currentTarget.style.color = 'black'}
              >
                  {source?.name ? source.name : "no source found"}
                </Button>
              ))}
              {isLoading && <Spinner UNSAFE_className={styles.loadingSpinner2} /> }

            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};

export default Answer;
